import { render, staticRenderFns } from "./IpChain.vue?vue&type=template&id=61986b7a&scoped=true"
import script from "./IpChain.vue?vue&type=script&lang=js"
export * from "./IpChain.vue?vue&type=script&lang=js"
import style0 from "./IpChain.vue?vue&type=style&index=0&id=61986b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61986b7a",
  null
  
)

export default component.exports